import { useEffect, useState } from 'react';
import { useVideoCallContext } from '@context/VideoCall';
import { OTPublisher, OTSession, OTStreams, OTSubscriber } from 'opentok-react';
import DisconnectedSubscriber from '../DisconnectedSubscriber';
import * as styles from './styles';

export interface OpentokError {
  code?: number;
  name: string;
  preventDefault(): void;
  isDefaultPrevented(): boolean;
}

const OPENTOK_API_KEY = '47450321';

const Video = () => {
  const {
    videoCallResponse,
    subscriberConnected,
    setSubscriberConnected,
    setNetworkStateConnected,
    setNetworkStateDisconnected,
    publishProps,
    initMediaSource
  } = useVideoCallContext();

  const [, setError] = useState<OpentokError | null>(null);

  useEffect(() => {
    initMediaSource();
  }, []);

  const publisherEventHandlers = {
    accessDenied: () => {
      console.log('User denied access to media source');
    },
    streamCreated: () => {
      console.log('Publisher stream created');
    },
    streamDestroyed: ({ reason }: { reason: string }) => {
      console.log(`Publisher stream destroyed because: ${reason}`);
    }
  };

  const onSessionError = (error: OpentokError) => {
    setError(error);
  };

  const onPublish = () => {
    console.log('Publish Success');
    setError(null);
  };

  const onPublishError = (error: OpentokError) => {
    setError(error);
  };

  const onSubscribe = () => {
    console.log('Subscribe Success');
  };

  const onSubscribeError = (error: OpentokError) => {
    setError(error);
  };

  return (
    <div css={styles.container}>
      {videoCallResponse ? (
        <OTSession
          apiKey={OPENTOK_API_KEY}
          sessionId={videoCallResponse?.opentokConnection.sessionId}
          token={videoCallResponse?.opentokConnection.token}
          onError={onSessionError}
          eventHandlers={{
            sessionReconnected: setNetworkStateConnected,
            sessionReconnecting: setNetworkStateDisconnected
          }}
        >
          <OTStreams>
            <OTSubscriber
              properties={{ width: '100%', height: '77vh', showControls: false }}
              onSubscribe={onSubscribe}
              onError={onSubscribeError}
              eventHandlers={{
                connected: () => setSubscriberConnected(true),
                destroyed: () => setSubscriberConnected(false)
              }}
            />
          </OTStreams>
          {!subscriberConnected && <DisconnectedSubscriber />}
          <div css={styles.publisherWrapper}>
            <OTPublisher
              properties={publishProps}
              onPublish={onPublish}
              onError={onPublishError}
              eventHandlers={publisherEventHandlers}
            />
          </div>
        </OTSession>
      ) : (
        <DisconnectedSubscriber />
      )}
    </div>
  );
};

export default Video;
